import React, { Component } from "react";
import { Page } from "pages/page";
import { faPuzzlePiece } from "@fortawesome/free-solid-svg-icons";
import { faChrome, faFirefox } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./index.module.scss";

class Extension extends Component {
	public readonly chromeURL = "https://chrome.google.com/webstore/detail/fangamearchive/lfepciaekhcpaimdodchemnfddniaceh";
	public readonly firefoxURL = "https://addons.mozilla.org/en-US/firefox/addon/fangame-archive/";

	public render (): JSX.Element {
		return <div className={ styles.wrapper }>
			<div className={ styles.intro }>
				<p>
					We have a chrome extension to add missing download links on delicious-fruit wherever possible.
				</p>
				<p>You can install it from here:</p>
			</div>
			<div className={ styles.cards }>
				<a
					href={ this.chromeURL }
					className={ styles.card }
					target="_blank"
					rel="noopener noreferrer"
				>
					<span className={ `${ styles.icon } ${ styles.chromeIcon }` }>
						<FontAwesomeIcon icon={ faChrome } />
					</span>
					<span className={ styles.label }>Google Chrome</span>
				</a>
				<a
					href={ this.firefoxURL }
					className={ styles.card }
					target="_blank"
					rel="noopener noreferrer"
				>
					<span className={ `${ styles.icon } ${ styles.firefoxIcon }` }>
						<FontAwesomeIcon icon={ faFirefox } />
					</span>
					<span className={ styles.label }>Mozilla Firefox</span>
				</a>
			</div>
		</div>;
	}
}

const page = new Page({
	name: "Extension",
	content: <Extension />,
	icon: faPuzzlePiece,
});

export default page;
